export const enum EStaleTime {
  TwoMinutes = 1000 * 60 * 2,
  FiveMinutes = 1000 * 60 * 5,
  OneHour = 1000 * 60 * 60,
  OneDay = 1000 * 60 * 60 * 24,
}
